import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { environment } from '@environment/environment';
import { map, catchError } from 'rxjs/operators';
import { Domaine } from '@app/models/domaine';

@Injectable()
export class DomaineService {
    constructor(
        private httpClient: HttpClient
    ) { }

    // tous les domaines
    getDomaines(object=null) {
        return this.httpClient.post<any>(`${environment.apiEndPoint}domaines`, object)
            .pipe(
                map(res => res ? res.document.records as Domaine[] : []),
                catchError(this.handleError)
            );
    }

    // le catalogue: filtres
    //- options null
    //- propositions user published/pending/rejected
    //- wishes user
    getCatalogueWishOptionProp(object=null){
        return this.httpClient
            .post<any>(`${environment.apiEndPoint}domaines/read_catalogue`, object)
            .pipe(
                map(res => res ? res.document.records as Domaine[] : []),
                catchError(this.handleError)
            );
    }

    // liste des domaines pour un ID utilisateur donné
    getDomainesByUserId(id) {
        return this.httpClient
            .post<any>(`${environment.apiEndPoint}domaines/read_user`, JSON.stringify({ id: `${id}` }))
            .pipe(
                map(res => res ? res.document.records as Domaine[] : []),
                catchError(this.handleError)
            );
    }

    getFilteredDomaines(object){
        return this.httpClient
            .post<any>(`${environment.apiEndPoint}domaines/read_filter`, object)
            .pipe(
                map(res => res ? res.document.records as Domaine[] : []),
                catchError(this.handleError)
            );
    }

    // liste des 5 derniers domaines
    getLastDomaines() {
        return this.httpClient
            .get<any>(`${environment.apiEndPoint}domaines/read_preview`)
            .pipe(
                map(res => res ? res.document.records as Domaine[] : []),
                catchError(this.handleError)
            );
    }

    // Admin : recuperation de tous les domaines
    getDomainesToManage() {
        return this.httpClient
        .get<any>(`${environment.apiEndPoint}domaines/read_manage`)
            .pipe(
                map(res => res ? res.document.records as Domaine[] : []),
                catchError(this.handleError)
            );
    }

    // un domaine par son ID
    getDomaineById(object: any) {
        return this.httpClient
            .post<any>(`${environment.apiEndPoint}domaine/read_one`, object)
            .pipe(
                map(res => res.document as Domaine),
                catchError(this.handleError)
            );
    }

    // creation domaine
    createDomaine(object: any) {
        return this.httpClient
            .post(`${environment.apiEndPoint}domaine/create`, object)
            .pipe(
                map(res => res),
                catchError(this.handleError)
            );
    }

    // mise a jour domaine
    updateDomaine(object: any) {
        return this.httpClient
            .post(`${environment.apiEndPoint}domaine/update`, object)
            .pipe(
                map(res => res as Domaine),
                catchError(this.handleError)
            );
    }

    // Admin: mise a jour domaine
    updateDomaineToManage(object: any) {
        return this.httpClient
            .post(`${environment.apiEndPoint}domaine/update_manage`, object)
            .pipe(
                map(res => res as Domaine),
                catchError(this.handleError)
            );
    }

    deleteDomaine(object: Domaine) {
        return this.httpClient
            .post(`${environment.apiEndPoint}domaine/delete`, object)
            .pipe(
                map(() => null),
                catchError(this.handleError)
            );
    }

    // Admin
    deleteListDomaine(stringList: string) {
        return this.httpClient
            .post(`${environment.apiEndPoint}domaine/delete_manage`, JSON.stringify({ listId: `${stringList}` }))
            .pipe(
                map(() => null),
                catchError(this.handleError)
            );
    }

    disableDomaine(object: Domaine) {
        return this.httpClient
            .post(`${environment.apiEndPoint}domaine/disable`, object)
            .pipe(
                map(res => res as Domaine),
                catchError(this.handleError)
            );
    }

    // Vérification du ownership d'un domaine pour une url donnée
    verifyDomain(object) {
        return this.httpClient
            .post<any>(`${environment.apiEndPoint}domaine/verify`, object)
            .pipe(
                map(res => res.document),
                catchError(this.handleError)
            );
    }

    // Vérification de l'activité d'un domaine pour une url donnée
    checkUrlDomain(object) {
        return this.httpClient
            .post<any>(`${environment.apiEndPoint}domaine/check`, object)
            .pipe(
                map(res => res),
                catchError(this.handleError)
            );
    }

    private handleError(error: any): Promise<any> {
        let retour = error?.error?.message || error?.message || error;
        if(error?.error?.data) retour += '<br />'+error?.error?.data;
        return Promise.reject(retour);
    }
}